import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/resolving': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M281.2 278.2C327.2 264.9 330.8 254.7 325.2 234.8L314 195.5C307.9 174.6 295.6 167.4 242.9 182.7L54.7 236.8 83.3 335.4 281.2 278.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5L229.1 133.6C263.9 123.4 283.3 121.9 308.4 125.4 344.7 131.5 361.1 150.4 369.8 180.6L380.5 218.4C388.7 246.5 381.5 269 357 292 337.6 309.4 325.8 316.5 295.6 325.2L203 351.8 423.4 378.9 433.1 413.1 385 426.4 98.2 389.1 121.2 469.3C158 491.3 201.5 504 247.5 504 384.5 504 496 392.6 496 255.7 497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8C0 305.3 14.3 350.2 38.3 388.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/resolving.js
// module id = OnHZ
// module chunks = 144